<ng-container *ngIf="accountMessages && accountMessages?.msgCd !== 'NOMSG'">
  <ng-container
    *ngIf="(accountMessages.msgCd !== 'SMALLCHG') || (accountMessages.msgCd === 'SMALLCHG' && hasSingleNudge())">
    <acct-msg [metadata]="accountMessages"></acct-msg>
  </ng-container>
</ng-container>